export default __webpack_public_path__ + "static/media/selectTriangle.35564b5e.svg";